import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { showToast } from "../components/Toast";

const CreateMeetingPoll = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    duration_minutes: 60,
    description: "",
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Create Meeting Poll
          </h1>
          <p className="text-gray-600">
            Find the best time for everyone by creating a poll
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="apple-card p-12"
        >
          <div className="text-center py-16">
            <div className="text-6xl mb-6">📊</div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Coming Soon
            </h2>
            <p className="text-gray-600 mb-8 max-w-md mx-auto">
              Meeting polls are currently under development. This feature will allow you to
              propose multiple time slots and let participants vote on their availability.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 max-w-md mx-auto mb-8">
              <h3 className="font-semibold text-gray-900 mb-3">What to expect:</h3>
              <ul className="text-left text-sm text-gray-600 space-y-2">
                <li className="flex items-start gap-2">
                  <span className="text-blue-600">✓</span>
                  <span>Propose multiple date and time options</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600">✓</span>
                  <span>Participants vote on their availability</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600">✓</span>
                  <span>Automatic selection of the most popular time</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600">✓</span>
                  <span>Calendar integration for easy scheduling</span>
                </li>
              </ul>
            </div>

            <button
              onClick={() => navigate("/calendar/select-link-type")}
              className="apple-btn-primary"
            >
              ← Back to Link Types
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CreateMeetingPoll;
